import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import {
  executeAction,
  executeDownload,
  executeDownloadFolder,
  isLoading,
  isSecondaryLoading,
  getData
} from '../../../../redux/actions/admin/fileManager/browse'

import FileManager from '../../../../components/fileManager/main'

const Browse = (props) => {
  const dispatch = useDispatch()

  const onExcuteAction = (form) => dispatch(executeAction(form))
  const onExcuteDownload = (path, name) => dispatch(executeDownload(path, name))
  const onExcuteDownloadFolder = (path, name) => dispatch(executeDownloadFolder(path, name))

  const loading = useSelector(isLoading)
  const secondaryLoading = useSelector(isSecondaryLoading)
  const data = useSelector(getData)

  return (
    <FileManager
      allowZipFolder={false}
      storage={props.storage}
      defaults={props.defaults}
      data={data}
      loading={loading}
      secondaryLoading={secondaryLoading}
      executeAction={onExcuteAction}
      executeDownload={onExcuteDownload}
      executeDownloadFolder={onExcuteDownloadFolder}
    />
  )
}

export default Browse
